<template>
  <stat-sheet :sheet="combatant" @update="updateSheet" />
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { updateProps } from '@/utilities/helpers'
import StatSheet from '@/components/StatSheet'

export default {
  name: `CombatantSheet`,
  components: {
    StatSheet,
  },

  props: {
    id: {
      type: String,
      default: null,
    },
  },

  created() {
    this.bindCombatantRef(this.id)
  },

  computed: {
    ...mapState(`combatant/sheet`, [`combatant`]),
  },

  methods: {
    ...mapActions(`combatant/sheet`, [`bindCombatantRef`, `update`]),

    updateProps,

    updateSheet(value) {
      this.updateProps({ ...this.combatant, initiative: value * 1 })
    },

    // TODO: conditional so 'back' link only shows if same domain.
  },
}
</script>
